import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { csLogin } from "../../api/auth.api";
import { csSession } from "../../auth/session";
import styles from "../../styles/login.module.css";

export default function Login() {
  const nav = useNavigate();
  const [form, setForm] = useState({ phone: "", password: "" });
  const [msg, setMsg] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e?.preventDefault?.();
    if (loading) return;

    setMsg("");

    if (!form.phone.trim()) return setMsg("Telefon nömrəsini daxil edin.");
    if (!form.password.trim()) return setMsg("Şifrəni daxil edin.");

    try {
      setLoading(true);
      const res = await csLogin(form);

      const payload = res?.data?.data ?? res?.data ?? res;

      csSession.setUser(payload);

      const verifyStatus = String(payload?.verifyStatus || "").toUpperCase();

      // 🔑 TELEFON NORMALIZE (səndəki kimi)
      const rawPhone = String(payload?.phone || form.phone).replace(/\s+/g, "");
      let normalizedPhone = rawPhone;
      if (rawPhone.startsWith("994")) normalizedPhone = "0" + rawPhone.slice(3);
      if (rawPhone.startsWith("+994")) normalizedPhone = "0" + rawPhone.slice(4);

      // 🔐 ADMIN
      if (normalizedPhone === "0773134223") {
        nav("/couriersub/admin/users", { replace: true });
        return;
      }

      // ✅ Telefon doğrulanmayıbsa -> verify
      if (verifyStatus === "PHONE_PENDING") {
        nav("/couriersub/verify", { replace: true });
        return;
      }

      // ✅ Əks halda dashboard
      nav("/couriersub/dashboard", { replace: true });

    } catch (err) {
      const apiMsg =
        err?.response?.data?.message ||
        err?.response?.data?.error ||
        err?.message ||
        "Giriş alınmadı. Yenidən cəhd edin.";
      setMsg(apiMsg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={styles.page}>
      <div className={styles.card}>
        <div className={styles.header}>
          <div className={styles.brand}>MotoTaksi.az</div>
          <h1 className={styles.title}>Kuryer Abunəliyi</h1>
          <p className={styles.subtitle}>Hesabınıza daxil olun.</p>
        </div>

        <form className={styles.form} onSubmit={submit}>
          <label className={styles.label}>Telefon</label>
          <input
            className={styles.input}
            placeholder="0501234567"
            value={form.phone}
            onChange={(e) => setForm((p) => ({ ...p, phone: e.target.value }))}
            inputMode="tel"
            autoComplete="username"
          />

          <label className={styles.label}>Şifrə</label>
          <input
            className={styles.input}
            placeholder="••••••••"
            type="password"
            value={form.password}
            onChange={(e) => setForm((p) => ({ ...p, password: e.target.value }))}
            autoComplete="current-password"
          />

          <button className={styles.btn} type="submit" disabled={loading}>
            {loading ? "Daxil olunur..." : "Daxil ol"}
          </button>

          {msg && <div className={styles.error}>{msg}</div>}

          <div className={styles.footer}>
            Hesab yoxdur?{" "}
            <Link className={styles.link} to="/couriersub/register">
              Qeydiyyat
            </Link>

            <div style={{ marginTop: 8 }}>
              <Link className={styles.link} to="/couriersub/reset-password">
                Şifrəni unutdum?
              </Link>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
}

